import styled from 'styled-components';

const Page = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 50;
`;

export default Page;



// WEBPACK FOOTER //
// ./client/components/shared/Page/index.js